import { Breadcrumbs } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { change } from 'redux-form';
import { notifySet } from '../../Services/Actions/CommonActions';
import { getFields, isEmpty, STATUS_MSG } from '../../Services/config/globals';
import { uploadImages } from '../../Services/Utils/CommonApis';
import { getImage } from '../../Services/Utils/FileApis';
import { categoryUpdate, getCategory } from '../../Services/Utils/ServiceProviderApis';
import CategoryForm from './CategoryForm';

function EditCategory() {
  const params = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    getCategory({ id: params.id }).then((res) => {
      dispatch(change('categoryForm', 'categoryName', res.view.name));
      const logoView = [];
      logoView.push({
        uid: res.view.bannerFileView?.id,
        id: res.view.bannerFileView?.id,
        name: res.view.bannerFileView?.name,
        status: 'done',
        url: getImage(res.view.bannerFileView),
        fileId: res.view.bannerFileView?.fileId,
      });
      setLogoImage(logoView);
    });
  }, []);
  const [logoImage, setLogoImage] = useState([]);
  const handleChangeLogo = ({ fileList: newFileList }) => {
    setLogoImage(newFileList);
  };
  const logoImages = getFields(logoImage, 'originFileObj');

  const onButtonClick = (formData) => {
    if (!logoImage.fileId || logoImages) {
      uploadImages({ file: logoImages[0] }).then((res) => {
        const data = {
          id: params.id,
          name: formData.categoryName,
          keyword: formData.categoryName,
          order: 2,
          bannerFileView: {
            fileId: logoImage[0]?.fileId || res.view.fileId,
          },
        };
        categoryUpdate(data).then((resp) => {
          if (isEmpty(logoImage)) {
            dispatch(notifySet({ type: 'error', message: STATUS_MSG.uploadLogo }));
          } else if (resp.status === true) {
            navigate('/categories');
            dispatch(notifySet({ type: 'success', message: resp.message }));
          } else if (resp.status === -1) {
            dispatch(notifySet({ type: 'error', message: resp.message }));
          }
        });
      });
    }
  };
  return (
    <div className="container-fluid ">
      <div className="breadcrumb-menu-con">
        <Breadcrumbs
          separator=">"
          aria-label="breadcrumb"
        >
          <Link to="/categories">Categories</Link>
          <Link to="#">Edit Category</Link>
        </Breadcrumbs>
      </div>
      <div className="row">
        <div className="col-sm-12">
          <CategoryForm
            onButtonClick={onButtonClick}
            buttonSaveText="Save"
            logoImage={logoImage}
            handleChangeLogo={handleChangeLogo}
            categoryText="Edit Category"
            action="edit"
          />
        </div>
      </div>
    </div>
  );
}

export default EditCategory;
